import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'apc-unlink-project',
  templateUrl: './unlink-project.component.html',
  styleUrls: ['./unlink-project.component.scss', '../../project-management/project-management.component.scss']
})
export class UnlinkProjectComponent implements OnInit{
  @Input() modalRef: any;
  @Input() unlinkText: any;
  @Input() showProductsDecision: boolean;
  @Input() budgets: any;
  budgetDecision: string = "release";
  migrateId: string;
  public migrationForm: UntypedFormGroup;

  constructor() { }

  ngOnInit() {
    this.migrationForm = new UntypedFormGroup({
      budgetToMigrate: new UntypedFormControl(null, Validators.required),
    });
  }

  close(res: boolean) {
    this.modalRef.dismiss({ answer: res, migrateId: this.migrationForm.value.budgetToMigrate?.identifier, selectedMigrationBudgetName: this.migrationForm.value.budgetToMigrate?.name });
  }


}
